import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { syncGuestDataToServer } from "../utils/syncGuestData";
import { GoogleLogin } from "@react-oauth/google";

const Login = () => {
  const navigate = useNavigate();
  const [showpasswaord, setShowPassword] = useState();
  const [formData, setFormData] = useState({
    mobile: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };


  const handleGoogleLogin = async (credentialResponse) => {
  try {

    console.log("GOOGLE ID TOKEN:", credentialResponse.credential);

    const response = await axios.post(
      "https://cyberathon.com/streekatha/API/index.php/Master_controller/google_login",
      {
        token: credentialResponse.credential,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Google Login Response:", response.data);

    if (response.data.success === true) {
      toast.success(
        response.data.message || "Login successful via Google"
      );

      // Your API returns user inside data.user
      const user = response.data.data?.user;

      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
      }

      // If backend returns your application's token
      if (response.data.data?.token) {
        localStorage.setItem("token", response.data.data.token);
      }

      // Redirect after successful login
      setTimeout(() => {
        navigate("/");
      }, 500);
    } else {
      toast.error(
        response.data.message || "Google login failed"
      );
    }
  } catch (error) {
    console.error("Google login error:", error);
    console.error("Backend response:", error.response?.data);

    toast.error(
      error.response?.data?.message ||
      "Google login failed"
    );
  }
};

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.mobile.trim() || !formData.password.trim()) {
    toast.error("Please enter both fields.");
    return;
  }

  try {
    const response = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Login_Controller/user_login",
      formData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    console.log("Login Response", response.data);

    if (response.data.success === "1" && response.data.status === "true") {

      const userData = response.data.result;
      const userId = userData.user_id;

      if(userData.status !== "active"){
        toast.warn("Your account has deactived!");
        return;
      }else{
      toast.success("Login successful!");
      }

      // ✅ STEP 1: SYNC GUEST DATA FIRST (🔥 MOST IMPORTANT)
      await syncGuestDataToServer(userId);

      // ✅ STEP 2: Clear only OLD USER data (NOT guest data)
      localStorage.removeItem("user");
      localStorage.removeItem("user_id");

      // ❌ DO NOT REMOVE guest_cart & guest_wishlist here
      // syncGuestDataToServer already clears them safely

      // ✅ STEP 3: Save logged-in user
      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem("user_id", userId);

      console.log("Logged in user data:", userData);

      // ✅ STEP 4: Notify Navbar
      window.dispatchEvent(new Event("userLoggedIn"));

      setTimeout(() => {
        navigate("/");
      }, 1000);
    } else {
      toast.error(response.data.message || "Invalid credentials.");
    }
  } catch (err) {
    console.error("Login error:", err);
    toast.error(
      err.response?.data?.message || "Invalid mobile/email or password."
    );
  }
};


  return (
    <div className="container-fluid login-section">
      <div id="loginbox">
        <img
          src="https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/2021/7/14/1db28809-f3db-48b1-b303-d937716565661626257521634-Banner_Hamburger--2---1-.jpg"
          alt="Login Banner"
        />
        <div className="loginbody">
          <div className="loginheader">
            Login <span id="smallheader">Or </span>Signup
          </div>

          <form onSubmit={handleSubmit} id="login">
            <label>
              Mobile No. <span id="smallheader">Or </span> Email
            </label>
            <input
              required
              placeholder="Enter Your Mobile Number Or Email"
              name="mobile"
              id="mobile"
              type="text"
              value={formData.mobile}
              onChange={handleChange}
            />

            
            <label>Password</label>
            {/* <div className={{position:"relative"}}>
            <input
              type={showpasswaord ? "text" : "password"}
              required
              placeholder="Enter Your Password"
              name="password"
              id="password"
              value={formData.password}
              onChange={handleChange}
              style={{ paddingRight: 40 }}
            />
            <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            style={{
                  position: "absolute", right: 12, top: "50%",
                  transform: "translateY(-50%)", background: "none",
                  border: "none", cursor: "pointer", fontSize: 17, lineHeight: 1,
                }}
                aria-label="Toggle password visibility"
            >
              {showpasswaord ? "🙈" : "👁️"}
            </button>
            </div> */}

            <div style={{ position: "relative" }}>
              <input
                type={showpasswaord ? "text" : "password"}
                name="password"
                placeholder="Enter your passwaord"
                value={formData.password}
                onChange={handleChange}
                required
                style={{ paddingRight: 40 }}
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                style={{
                  position: "absolute", right: 12, top: "50%",
                  transform: "translateY(-50%)", background: "none",
                  border: "none", cursor: "pointer", fontSize: 17, lineHeight: 1,
                }}
                aria-label="Toggle password visibility"
              >
                {showpasswaord ? "🙈" : "👁️"}
              </button>
            </div>

            <button type="submit" className="continue">
              CONTINUE
            </button>

            <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 10,
      margin: "15px 0",
      color: "#999",
      fontSize: 13,
    }}
  >
    <div style={{ flex: 1, height: 1, background: "#ddd" }} />
    <span>OR</span>
    <div style={{ flex: 1, height: 1, background: "#ddd" }} />
  </div>

            {/* Google Login */}
  <div style={{ marginBottom: 20 }}>
    <GoogleLogin
  onSuccess={(credentialResponse) => {
    console.log("GOOGLE ID TOKEN:", credentialResponse.credential);
    handleGoogleLogin(credentialResponse);
  }}
  onError={() => {
    console.log("Google Login Failed");
  }}
/>
  </div>
          </form>

          <p>
            By continuing I agree to the{" "}
            <span className="smallhead">
              <Link to="/PrivacyPolicy"> Terms of Use </Link>
            </span>
            &amp;
            <span id="small">
              <Link to="/PrivacyPolicy"> Privacy Policy </Link>
            </span>
          </p>

          <p>
            Don't have an account?{" "}
            <Link to="/signin">
              <span style={{ cursor: "pointer" }}>Signup</span>
            </Link>
          </p>

          <div id="alert" />
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Login;